<div class="wrapper">
  <div class="heading text-type-2 mb-[40px]">
    {{ laborName || 'Add labor' }}
  </div>
  <form>
    <app-dropdown
      (addNewClicked)="openAddContractorDialog()"
      (checkForErrors)="checkForErrors($event)"
      [enableAddNew]="true"
      [enableSearch]="subContractorOptions.length >= 10"
      [error]="errorMessages['sub_contractor']"
      [options]="subContractorOptions"
      [parentFormGroup]="form"
      class="mb-[20px]"
      controlName="sub_contractor"
      label="Contractor"
    />
    @if (form.controls['sub_contractor']?.value) {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [options]="personnelTypeOptions"
        [parentFormGroup]="form"
        [error]="errorMessages['personnel_type']"
        [sentenceCase]="true"
        class="mb-[20px]"
        controlName="personnel_type"
        label="Employee generic vendor personal"
      />
    }
    @if (form.controls['personnel_type']?.value === 'employee') {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableMultiple]="true"
        [enableSearch]="true"
        [showCount]="true"
        [error]="errorMessages['employees']"
        [options]="employeeOptions"
        [parentFormGroup]="form"
        selectionString="selected"
        class="mb-[20px]"
        controlName="employees"
        label="Select employee"
      />
      @for (employee of selectedEmployees; track employee) {
        <div class="entry-accordion mb-[12px]">
          <div
            (click)="toggleAccordion(employee)"
            class="entry-header"
          >
            <div class="entry-heading text-type-13">{{ employee.label | sentenceCase }}</div>
            <mat-icon class="chevron-icon" [class.is-expanded]="expandedEmployees[employee.value]">expand_more</mat-icon>
          </div>
          @if (expandedEmployees[employee.value]) {
            <div class="entry-content">
              <app-number-input
                [parentFormGroup]="employeeForms[employee.value]"
                class="mb-[20px]"
                controlName="hours"
                [isDecimalAllowed]="true"
                label="Hours"
              />
              <app-text-area
                [parentFormGroup]="employeeForms[employee.value]"
                class="mb-[20px]"
                controlName="comment"
                label="Comment"
              />
            </div>
          }
        </div>
      }
    }
    @if (form.controls['personnel_type']?.value === 'generic_personal') {
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableMultiple]="true"
        [enableSearch]="true"
        [showCount]="true"
        [error]="errorMessages['generic_personals']"
        [options]="genericPersonalOptions"
        [parentFormGroup]="form"
        selectionString="selected"
        class="mb-[20px]"
        controlName="generic_personals"
        label="Select generic personal"
      />
      @for (gp of selectedGenericPersonals; track gp) {
        <div class="entry-accordion mb-[12px]">
          <div
            (click)="toggleGenericPersonalAccordion(gp)"
            class="entry-header"
          >
            <div class="entry-heading text-type-13">{{ gp.label | sentenceCase }}</div>
            <mat-icon class="chevron-icon" [class.is-expanded]="expandedGenericPersonals[gp.value]">expand_more</mat-icon>
          </div>
          @if (expandedGenericPersonals[gp.value]) {
            <div class="entry-content">
              <div class="flex flex-row gap-[20px] w-full mb-[20px]">
                <app-number-input
                  [parentFormGroup]="genericPersonalForms[gp.value]"
                  class="w-1/2"
                  controlName="quantity"
                  label="Quantity"
                />
                <app-number-input
                  [parentFormGroup]="genericPersonalForms[gp.value]"
                  class="w-1/2"
                  controlName="hours"
                  [isDecimalAllowed]="true"
                  label="Hours"
                />
              </div>
              <app-text-area
                [parentFormGroup]="genericPersonalForms[gp.value]"
                class="mb-[20px]"
                controlName="comment"
                label="Comment"
              />
            </div>
          }
        </div>
      }
    }
  </form>
</div>
